'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.prettyPrint = prettyPrint;
exports.calculateRanges = calculateRanges;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _availability = require('availability');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conjunct = _availability.iteratorFactory.conjunct,
    disjunct = _availability.iteratorFactory.disjunct;
function prettyPrint(_ref) {
    var i18n = _ref.i18n,
        cal = _ref.cal,
        availabilities = _ref.availabilities,
        openTimes = _ref.openTimes,
        _ref$formatTime = _ref.formatTime,
        formatTime = _ref$formatTime === undefined ? defaultTimeFormatter : _ref$formatTime;

    formatTime = _lodash2.default.partial(formatTime, i18n.getLocale ? i18n.getLocale() : 'en_US');
    var ranges = calculateRanges({ cal: cal, availabilities: availabilities, openTimes: openTimes });
    var text = '';

    for (var i = 0; i < ranges.length; i++) {
        var cur = ranges[i];
        var curText = void 0;

        var openClosedString = cur.status === 'available' ? getOpenedString(i18n) : getClosedString(i18n);

        if (i === 0) {
            if (!cur.until) curText = '' + openClosedString;else curText = openClosedString + ': ' + getUntilString(i18n, formatTime(cur.until));
        } else if (i > 0 && i === ranges.length - 1) {
            curText = openClosedString + ': ' + getFromString(i18n, formatTime(ranges[i - 1].until));
        } else {
            curText = openClosedString + ': ' + formatTime(ranges[i - 1].until) + ' - ' + formatTime(ranges[i].until);
        }

        text += '<div className=\'exception-range\'>' + curText + '</div>';
    }

    return text;
}

function calculateRanges(_ref2) {
    var cal = _ref2.cal,
        availabilities = _ref2.availabilities,
        _ref2$openTimes = _ref2.openTimes,
        openTimes = _ref2$openTimes === undefined ? { weekly: [] } : _ref2$openTimes;

    if (!isDateExceptioned({ cal: cal, exceptions: _lodash2.default.map(availabilities, 'exceptions'), openTimesExceptions: openTimes.exceptions })) return [];

    openTimes = getOpenTimes(openTimes);

    var disjuncted = disjunct(_lodash2.default.map(availabilities, function (a) {
        return conjunct(a, openTimes);
    }))(cal);

    var ranges = [];

    while (disjuncted.hasNext()) {
        var rangeState = disjuncted.next();

        if (rangeState.until < cal.clone().endOf('d').unix() * 1000) ranges.push(rangeState);else {
            ranges.push({
                until: null,
                status: rangeState.status
            });
            break;
        }
    }

    return ranges;
}

function getClosedString(i18n) {
    return i18n.get('exceptions_printer_closed', 'Closed');
}

function getOpenedString(i18n) {
    return i18n.get('exceptions_printer_opened', 'Opened');
}

function getUntilString(i18n, formattedTime) {
    return i18n.get('exceptions_printer_until', 'until ${params.time}', {
        params: {
            time: formattedTime
        }
    });
}

function getFromString(i18n, formattedTime) {
    return i18n.get('exceptions_printer_from', 'from ${params.time}', {
        params: {
            time: formattedTime
        }
    });
}

function defaultTimeFormatter(locale, time) {
    return (0, _moment2.default)(time).locale(locale).format('LT');
}

function getOpenTimes(openTimes) {
    return _lodash2.default.get(openTimes, 'weekly.length', 0) === 0 ? getAlwaysAvailable() : openTimes;
}

function getAlwaysAvailable() {
    return { weekly: [{ minuteOfWeek: 0, durationMins: 10080 }] };
}

function isDateExceptioned(_ref3) {
    var cal = _ref3.cal,
        exceptions = _ref3.exceptions,
        openTimesExceptions = _ref3.openTimesExceptions;

    function isDateIncluded(cal, exceptions) {
        var defaultStart = { year: 1970, month: 1, day: 1, minute: 0, hour: 0 };
        var defaultEnd = { year: 2100, month: 1, day: 1, minute: 0, hour: 0 };

        return _lodash2.default.some(exceptions, function (e) {
            return toMoment(e.start || defaultStart).startOf('d') <= cal && cal <= toMoment(e.end || defaultEnd).endOf('d');
        });
    }

    return _lodash2.default.some([].concat((0, _toConsumableArray3.default)(exceptions), [openTimesExceptions]), function (e) {
        return isDateIncluded(cal, e);
    });
}

function toMoment(_ref4) {
    var year = _ref4.year,
        month = _ref4.month,
        day = _ref4.day,
        hour = _ref4.hour,
        minute = _ref4.minute;

    return (0, _moment2.default)().year(year).month(month - 1).date(day).hour(hour).minute(minute);
}